import React from 'react'
import styled, { css } from 'styled-components'
import { Button, Price, Typography } from '../../../Common'

import {
  useBasketTotalCount,
  useOrderPrice,
  usePrice,
  useUIFunctions,
  useConfigState,
  useGoToCheckout,
  useLocalLabels,
  useScrollTo,
} from '@sentecacommerce-theme/lib'
import { BasketLabels } from '../../basket.props'
import { AuthPopupProps } from '../../../Common/Modals'
import { FreeShippingLabel } from '../FreeShippingLabel'
import { useRouter } from 'next/router'

export const Summary = ({
  hideCode,
  getFirstElementWithError,
}: {
  hideCode?: boolean
  getFirstElementWithError: () => HTMLDivElement | undefined
}) => {
  const { subtotal } = useOrderPrice()
  const { enqueueView } = useUIFunctions()
  const config = useConfigState()
  const router = useRouter()
  const { scrollTo } = useScrollTo()
  const { price: formattedSubtotalPrice } = usePrice({
    price: subtotal,
    discountedPrice: undefined,
  })

  const itemsInBasketTotalCount = useBasketTotalCount()

  const isBasketEmpty = Boolean(itemsInBasketTotalCount === 0)
  const labels = useLocalLabels<BasketLabels>()

  const totalPrice = +`${formattedSubtotalPrice.price}.${formattedSubtotalPrice.pennies}`

  const openAuthModal = () => {
    enqueueView<AuthPopupProps>(config.views.auth, {
      isCheckout: true,
    })
  }
  const goToCheckout = () => {
    router.push('/checkout', undefined, { shallow: true })
  }

  const [handleClick, { isLoading }] = useGoToCheckout({
    authenticatedCallback: goToCheckout,
    guestCallback: openAuthModal,
    onErrorCallback: () => {
      setTimeout(() => {
        scrollTo(getFirstElementWithError() ?? 0)
      })
    },
  })

  const isSubmitDisabled = isLoading || isBasketEmpty

  return (
    <Container>
      <Row noBorderTop={hideCode}>
        <Left>
          {labels?.products} ({itemsInBasketTotalCount})
        </Left>
        <Right>
          <Price
            hideDiscountPercentage
            size="md"
            price={totalPrice}
            currency={formattedSubtotalPrice?.currency}
          />
        </Right>
      </Row>
      <FreeShippingLabel className="mt-4" totalPrice={+totalPrice} />
      <Button
        className="mt-3"
        disabled={isSubmitDisabled}
        onClick={handleClick}
        variant={isSubmitDisabled ? 'disabled' : 'green'}
        fullWidth
      >
        {labels?.continueToCheckout}
      </Button>
    </Container>
  )
}

const Container = styled.div``

const Row = styled.div.attrs((props: any) => ({
  className: `d-flex align-items-center justify-content-between mb-4 ${
    props.noBorderTop ? '' : 'py-3'
  }`,
}))<{ small?: boolean; noBorderTop?: boolean }>`
  ${(props) => css`
    ${props.small &&
    css`
      & > span:first-child {
        font-size: 1.4rem;
      }
    `}
  `}

  &:last-of-type {
    border-top: 0.1rem solid
      ${(props) =>
        props.noBorderTop ? 'transparent' : props.theme.palette.lightgrey};
  }
`

const Left = styled(Typography).attrs({
  as: 'span',
  variant: 6,
  color: 'greyTitle',
})``

const Right = styled.span``
